module.exports = __webpack_public_path__ + "fonts/NunitoSans-SemiBold.8535f0d.ttf";